<script>
import PortalNav from "@/components/portal-nav";

/**
 * Layout del portal de clientes: barra propia y contenido a ancho de lectura.
 * No comparte nada con el layout del panel (`vertical.vue`), que trae barra
 * lateral, barra derecha y el menú de administración.
 */
export default {
  components: { PortalNav },
  created() {
    // El layout del panel deja atributos en el body que descuadran el portal.
    document.body.removeAttribute("data-sidebar");
    document.body.removeAttribute("data-layout");
    document.body.classList.remove("sidebar-enable", "vertical-collpsed");
  },
};
</script>

<template>
  <div class="portal-wrapper">
    <PortalNav />

    <main class="portal-contenido">
      <slot />
    </main>

    <footer class="portal-footer">
      <div>{{ new Date().getFullYear() }} © Reconstrucción Network</div>
    </footer>
  </div>
</template>

<style scoped>
.portal-wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #f6f6f9;
}

.portal-contenido {
  flex: 1;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 24px 16px 48px;
}

.portal-footer {
  background: #fff;
  border-top: 1px solid #e9ecef;
  padding: 16px;
  text-align: center;
  color: #74788d;
  font-size: 0.85rem;
}
</style>
